import {
  type ColorTypeSelect,
  type OptionalColorTypeSelect,
  type Color,
  type Shade,
  SHADES,
} from "@/components/expression/theme/types";

import type { NodeModel } from "@/models/nodes/types";

export function isConfigDisabled(
  config: ColorTypeSelect | OptionalColorTypeSelect,
): config is Maybe<OptionalColorTypeSelect> {
  if ("enabled" in config) {
    return !config.enabled;
  }

  return false;
}

export function mapColorConfigToColor(
  node: NodeModel,
  config: ColorTypeSelect | OptionalColorTypeSelect,
): Color | undefined {
  if (isConfigDisabled(config)) {
    return undefined;
  }

  switch (config.type) {
    case "colored": {
      if ("color" in node && node.color) {
        return `${node.color}-${config.shade}` as Color;
      }

      return undefined;
    }

    case "fixed": {
      return config.color;
    }

    default: {
      return undefined;
    }
  }
}

export function mirrorColor(color: Color): Color {
  switch (color) {
    case "white": {
      return "black";
    }

    case "black": {
      return "white";
    }

    case "transparent": {
      return "transparent";
    }

    default: {
      const [colorName, colorIntensity] = color.split("-");
      const currentIndex = SHADES.indexOf(colorIntensity as Shade);
      const mirroredIntensity = SHADES.slice().reverse()[currentIndex];

      return `${colorName}-${mirroredIntensity}` as Color;
    }
  }
}
